import type { useColors } from '../../contexts/ColorsProvider/ColorsProvider'
import type { useSizes } from '../../contexts/SizesProvider/SizesProvider'

export const getIsBackInStock = (
	hasRelatedSizes: boolean,
	hasOnlineSale: boolean,
	selectedSize: ReturnType<typeof useSizes>['selectedSize'],
	selectedColor: ReturnType<typeof useColors>['selectedColor']
): boolean => {
	if (!hasOnlineSale) {
		return false
	}

	if (hasRelatedSizes) {
		return !!selectedSize && !selectedSize.available
	}

	return !selectedColor.isSellable
}
